module.exports = __webpack_public_path__ + "input-user.png";